<template>
  <div>
    <LoadingIndicator v-if="isLoading" />
    <div v-if="product">
      <div>
        <div class="d-flex justify-content-between p-2">
          <div v-if="showBack">
            <el-button type="default" @click="$router.back()">
              <i class="el-icon-back" />
              <span v-t="'general.back'" />
            </el-button>
          </div>
          <div v-if="showCart">
            <el-button type="primary" @click="onAddToCart">
              <i class="el-icon-shopping-cart-1" />
              <span v-t="'general.add_to_cart'" />
            </el-button>
          </div>
        </div>
      </div>
      <div class="p-3 mt-3 h5 font-color-primary d-flex flex-column">
        <span v-html="product.get('name')" />
        <span class="small" v-html="product.get('description')" />
      </div>
      <el-card>
        <slot name="header">
          <span class="font-color-primary font-weight-bold">{{ $tc('general.attribute', 2) }}</span>
        </slot>
        <div class="py-3">
          <span class="d-block small font-weight-bold">{{ $tc('products.productgroup', 2) }}</span>
          <el-tag v-for="group in product.get('groups')" :key="group.id" class="m-1" size="mini">
            {{ group.get('name') }}
          </el-tag>
        </div>
        <div>
          <span class="d-block small font-weight-bold">{{ $tc('products.productattribute', 2) }}</span>
          <el-tag v-for="attribute in product.get('attributes')" :key="attribute.id" class="m-1" size="mini">
            {{ attribute.get('name') }}
          </el-tag>
        </div>
      </el-card>
      <el-card class="mt-3">
        <slot name="header">
          <span class="font-color-primary font-weight-bold">{{ $tc('general.files', 2) }}</span>
        </slot>
        <div>
          <el-link
            v-for="file in productFiles"
            :key="file.id"
            class="d-block py-2"
            @click="onFileSelect(file)"
            v-html="file.get('name')"
          />
          <div v-if="productFiles.length === 0">
            {{ $t('general.no_files') }}
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { Plugins } from '@capacitor/core';

const { Browser } = Plugins;

import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import LoadingIndicator from '../../components/loading/LoadingIndicator';
import AddProductModal from '../../components/modals/AddProductModal';
import PDFViewerModal from '../../components/modals/PDFViewerModal';
export default {
  name: 'ProductView',
  components: { LoadingIndicator },
  props: {
    productId: {
      type: [Number, String],
      default: null,
    },
    showBack: {
      type: Boolean,
      default: true,
    },
    showCart: {
      type: Boolean,
      default: true,
    },
  },
  async mounted() {
    this.loadProduct(parseInt(this.productId));
  },
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(StoreModules.PRODUCT_DETAIL, ['product', 'isLoading']),
    productFiles() {
      return this.product
        .get('files')
        .filter((el) => el.get('type') === 'product')
        .sort((a, b) => (a.get('mediaTypeId') > b.get('mediaTypeId') ? 1 : -1));
    },
  },
  methods: {
    ...mapActions(StoreModules.PRODUCT_DETAIL, ['loadProduct']),
    onAddToCart() {
      this.$modal.show(
        AddProductModal,
        { product: this.product },
        { height: 'auto', width: '90%', minWidth: 300, maxWidth: 300, adaptive: true }
      );
    },
    async onFileSelect(file) {
      try {
        await Browser.open({ url: file.get('sheet').url() });
      } catch (e) {
        this.$message.error('Could not open file');
      }
    },
  },
};
</script>

<style scoped></style>
